module.exports = __webpack_public_path__ + "img/xw-005.3ba4a9ce.jpg";